module.exports = __webpack_public_path__ + "static/the-goal-de321936992bb7d7f467e3f461781d44.jpg";